"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._ResourceList = exports._ResourceForm = exports._Form = void 0;
var _form = _interopRequireDefault(require("wever-core/dist/components/form"));
var _form2 = _interopRequireDefault(require("wever-core/dist/components/resources/form"));
var _list = _interopRequireDefault(require("wever-core/dist/components/resources/list"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const _ResourceForm = exports._ResourceForm = _form2.default;
const _ResourceList = exports._ResourceList = _list.default;
const _Form = exports._Form = _form.default;
var _default = exports.default = _form.default;